import type { TaskFlag } from '@travel-planner/shared/schemas/tasks';

export const TASK_FLAG = {
  none: 0,
  attention: 5,
  urgent: 10,
} as const satisfies Record<string, TaskFlag>;

/** Canonical flag values the filter UI and setFlag accept (TCT03-008). */
export const TASK_FLAG_VALUES: ReadonlyArray<TaskFlag> = [
  TASK_FLAG.none,
  TASK_FLAG.attention,
  TASK_FLAG.urgent,
];

/**
 * Legacy `determineFlagForTask` (TCT03-001 / TCT03-002):
 * - self-assigned (or no assignee) → Not Flagged (0)
 * - assigned to someone other than the creator → Attention (5)
 *
 * System/auto-assign and customer-urgent paths set flag explicitly
 * (`flag: 5` / `flag: 10`) at their call sites — they never go through this.
 */
export const determineFlagForTask = (
  assignedAccountId: string | undefined | null,
  creatorAccountId: string | undefined | null
): TaskFlag => {
  if (
    assignedAccountId &&
    creatorAccountId &&
    assignedAccountId !== creatorAccountId
  ) {
    return TASK_FLAG.attention;
  }
  return TASK_FLAG.none;
};

/**
 * Narrow `flag` from the wider `number | null` shape that Drizzle row
 * selects surface to the discriminated `TaskFlag | undefined` union the
 * client UI expects. Anything outside `{0,5,10}` collapses to `undefined`.
 */
export const coerceFlag = (
  flag: number | null | undefined
): TaskFlag | undefined => {
  if (flag === 0 || flag === 5 || flag === 10) return flag;
  return undefined;
};

export const flagToLabel = (flag: TaskFlag | null | undefined): string => {
  switch (flag) {
    case 10:
      return 'Urgent';
    case 5:
      return 'Attention';
    default:
      return 'None';
  }
};

export const flagToVariant = (
  flag: TaskFlag | null | undefined
): 'urgent' | 'attention' | 'none' => {
  switch (flag) {
    case 10:
      return 'urgent';
    case 5:
      return 'attention';
    default:
      return 'none';
  }
};
